import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AppState } from 'src/store';

export const ofsApi = createApi({
  reducerPath: 'ofsApi',
  baseQuery: fetchBaseQuery({
    // Use environment variable or fallback to localhost
    // baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://demo-appcontrol-center-api.huewine.com/app-control/',
       baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://rrmmarbles-api.huewine.com/app-control',
      // baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://test-appcontrol-api.huewine.com/app-control/',
    
    prepareHeaders: (headers, { getState }) => {
      const branchId = localStorage.getItem('branchID');
      const state = getState() as AppState;
      const { accessToken } = state.user?.data || {};

      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }

      headers.set('Content-Type', 'application/json');

      if (branchId) {
        headers.set('Branch-ID', branchId);
      }

      return headers;
    }
  }),
  tagTypes: ['User', 'Branch', 'Application', 'Organization', 'Category', 'Regional', 'UserRole', 'UserEntity'],
  endpoints: () => ({}),
  // Add global error handling
  keepUnusedDataFor: 300, // Keep data for 5 minutes
});
